import React from "react";
import * as S from "./styles";
import RoundInput from "@/components/RoundInput";
import { FutButton } from "@/components/FutButton";
import { useForm } from "react-hook-form";
import { api } from "@/services/api";
import { catchError } from "@/utils/catchError";
import { toast } from "react-toastify";

export default function Users() {
  const adminForm = useForm({
    defaultValues: {
      freeUser: "",
      childId: "",
      parentId: "",
    },
  });

  const submitFreeUser = async () => {
    try {
      const user = adminForm.getValues("freeUser");

      await api.post(`/admin/release-free-access/${user}`);

      toast.success("Liberado!");
    } catch (e) {
      const message = catchError(e);
      if (message) {
        toast.error(message);
        return;
      }
      toast.error(e as any);
    }
  };

  const submitAffiliate = async () => {
    try {
      const child = adminForm.getValues("childId");
      const parent = adminForm.getValues("parentId");

      await api.post("/admin/change-affiliate", {
        child_email: child,
        parent_email: parent,
      });

      toast.success("Feito Com Sucesso!");
    } catch (e) {
      const message = catchError(e);
      if (message) {
        toast.error(message);
        return;
      }
      toast.error(e as any);
    }
  };
  return (
    <S.GeralWrapper>
      <S.BubbleContainer>
        Liberar usuário por email:
        <RoundInput
          inputName="freeUser"
          control={adminForm.control}
          size="small"
          fullWidth
          placeholder="exemplo@email.com"
          sx={{ my: 1 }}
        />
        <FutButton  fullWidth onClick={submitFreeUser}>
          Liberar
        </FutButton>
      </S.BubbleContainer>
      <S.BubbleContainer>
        <S.WrapperAff>
          <S.Paff>Mudar Afiliação do usuário</S.Paff>

          <RoundInput
            inputName="childId"
            control={adminForm.control}
            size="small"
            fullWidth
            topLabel="Usuário recém cadastrado"
            placeholder="usuarioFilho@email.com"
          />
          <RoundInput
            inputName="parentId"
            control={adminForm.control}
            size="small"
            fullWidth
            topLabel="Usuário Pai"
            placeholder="usuarioPai@email.com"
          />
          <FutButton fullWidth onClick={submitAffiliate} sx={{ mt: 1 }}>
            Mudar
          </FutButton>
        </S.WrapperAff>
      </S.BubbleContainer>
    </S.GeralWrapper>
  );
}
